/** Tutorial mission 3 — Orbital Drop intro replay metadata (Sankrat + Drone 79). */

export const MISSION3_ORBITAL_DROP_INTRO = {
  missionId: 'chapter_1_mission_3',
  droneOrderId: 79,
  targetUnitOrderId: 34,
  targetZone: 'front',
};

export function buildMission3IntroOrbitalDropEntry(gameState, userId) {
  if (!gameState?.state || userId == null) return null;
  const allPlayerIds = gameState.players || Object.keys(gameState.state);
  const opponentId = allPlayerIds.find((pid) => String(pid) !== String(userId));
  if (opponentId == null) return null;

  const opponent = gameState.state[opponentId];
  if (!opponent) return null;

  const visibleDrones = (opponent.drones || []).filter((d) => d && !d.markedForRemoval);
  const drone79 = visibleDrones.find((d) => d.id === MISSION3_ORBITAL_DROP_INTRO.droneOrderId);
  if (!drone79) return null;

  const frontRow = opponent.playedOrders?.[MISSION3_ORBITAL_DROP_INTRO.targetZone];
  if (!Array.isArray(frontRow)) return null;

  let targetUnit = null;
  let targetSlotIndex = -1;
  frontRow.forEach((unit, idx) => {
    if (!unit || unit.id !== MISSION3_ORBITAL_DROP_INTRO.targetUnitOrderId) return;
    const hasWeapon = Array.isArray(unit.weapons) && unit.weapons.length > 0;
    if (!hasWeapon) return;
    targetUnit = unit;
    targetSlotIndex = idx;
  });

  if (!targetUnit || targetSlotIndex === -1) return null;

  const droneIndex = visibleDrones.findIndex((d) => d.instanceId === drone79.instanceId);
  if (droneIndex === -1) return null;

  const weapon = targetUnit.weapons[0];

  return {
    type: 'drone-orbital-drop-weapon-equipped',
    timestamp: Date.now(),
    sequence: 'mission3-intro-replay',
    ownerPlayerId: opponentId,
    droneOrderId: 79,
    droneInstanceId: drone79.instanceId,
    droneIndex,
    targetZone: MISSION3_ORBITAL_DROP_INTRO.targetZone,
    targetSlotIndex,
    targetUnitInstanceId: targetUnit.instanceId,
    targetUnitName: targetUnit.name,
    targetUnitOrderId: targetUnit.id,
    weaponId: weapon?.id,
    weaponName: weapon?.name,
    weaponInstanceId: weapon?.instanceId,
    isMission3IntroReplay: true,
  };
}

export function shouldScheduleMission3OrbitalDropIntro(gameState) {
  if (gameState?.missionId !== MISSION3_ORBITAL_DROP_INTRO.missionId) return false;
  if (!gameState?.campaignMode) return false;
  const turn = Number(gameState.turnNumber);
  if (!Number.isFinite(turn) || turn < 2) return false;
  const log = Array.isArray(gameState.actionLog) ? gameState.actionLog : [];
  const alreadyLogged = log.some(
    (e) => e && e.type === 'drone-orbital-drop-weapon-equipped'
  );
  if (alreadyLogged) return false;
  return true;
}
